import React from 'react';
import DocumentTitle from 'react-document-title';
// import { Popup, Picker } from 'spring-picker';
// import { provins, citys, areas } from '../addressPicker/picker-address/address';
import { PickerAddress } from '../addressPicker';
import { parseQuery } from '../../utils/tools';
import clientApi from '../../api/client';
import AXIOS from '../../api/axios';
import { COURSE_URL } from '../../constants';
import './style.less';
import { apiDefine, apiCancel } from '../../api/web';

const queryObj = parseQuery(window.location.search.slice(1));
export default class AddAddress extends React.PureComponent {
    state = {
        defaultAddress: ['北京市', '北京市', '东城区'],
        visible: false,
        address: '',
        canSubmit: false,
    }
    addressData = {
        userId: queryObj.stuid,
        consignee: null,
        consigneePhone: null,
        province: null,
        city: null,
        area: null,
        detail: null,
    }
    componentDidMount() {
        clientApi.backRequired({ backRequired: true });
        apiDefine({apiName: 'backConfirm', fn: this.backConfirm });
        apiDefine({apiName: 'alertViewBack', fn: this.alertViewBack });
        let clientData = clientApi.getClientDataSync({ data: ['userId'] }) || '{}';
        clientData = JSON.parse(clientData);
        this.addressData.userId = this.addressData.userId || clientData.userId;
    }
    componentWillUnmount() {
        apiCancel('backConfirm');
        apiCancel('alertViewBack');
    }
    backConfirm = () => {
        clientApi.alertView({
            id: 'H5_1001',
            confirm: '确定',
            cancel: '取消',
            content: '填写收货地址后才能领取奖励，确定退出当前页面吗？',
            title: '温馨提示'
        });
    }
    alertViewBack = (str) => {
        const data = JSON.parse(str);
        const { select, id } = data;
        if (id === 'H5_1001') {
            if (select === 'confirm') {
                const { history } = this.props;
                if (history.location.state && history.location.state.source) {
                    history.goBack();
                } else {
                    history.replace({
                        pathname: `${COURSE_URL}/daily/attendance`,
                        search:window.location.search,
                    });
                }
            }
        }
    }
    handleClose = (address) => {
        this.addressData.province = address[0] || '';
        this.addressData.city = address[1] || '';
        this.addressData.area = address[2] || '';

        this.setState({ visible: false, address: address.join(' '), canSubmit: Object.values(this.addressData).every(item => !!item) });
    }
    handleCancel = () => {
        this.setState({ visible: false });
    }
    onChange = address => {
        this.setState({ defaultAddress: [...address] });
    }
    showAddressPicker = () => {
        this.setState({ visible: true });
    }
    inputChange = (name, elem) => {
        this.addressData[name] = elem.target.value;
        this.setState({ canSubmit: Object.values(this.addressData).every(item => !!item) });
    }
    toSubmit = () => {
        const { canSubmit } = this.state;
        const errorMsg = [
            '收货人姓名需要在2-25个字符之间',
            '请输入正确的手机号码',
            '详细地址需要在5-120个字符之间',
        ];
        if (!canSubmit) { return; }
        const consigneeLen = this.addressData.consignee.trim().length;
        const detailLen = this.addressData.detail.trim().length;
        if (consigneeLen < 2 || consigneeLen > 25) { return this.alertView(errorMsg[0]); }
        if (!(/^1[0-9]{10}$/.test(this.addressData.consigneePhone))) { return this.alertView(errorMsg[1]); }
        if (detailLen < 5 || detailLen > 120) { return this.alertView(errorMsg[2]); }
        AXIOS.addDailyAttendanceAddress({
            data: this.addressData
        }, () => {
            const { history } = this.props;
            if (history.location.state && history.location.state.source) {
                history.goBack();
            } else {
                history.replace({
                    pathname: `${COURSE_URL}/daily/attendance`,
                    search:window.location.search,
                });
            }
        });
    }
    alertView = content => {
        clientApi.alertView({
            title:'提示',
            content,
            confirm:'确定',
            cancel:'取消',
            id:'H5_1002'
        })
    }
    render() {
        const { defaultAddress, visible, address, canSubmit } = this.state;
        return <DocumentTitle title="新增地址">
            <div className="AddAddressPage">
                <div className="address-box">
                    <div className="address-item">
                        <span className="address-label">收货人</span>
                        <input className="address-input" placeholder="收货人姓名" onChange={this.inputChange.bind(this, 'consignee')} />
                    </div>
                    <div className="address-item">
                        <span className="address-label">手机号码</span>
                        <input className="address-input" placeholder="收货人手机号码" onChange={this.inputChange.bind(this, 'consigneePhone')} />
                    </div>
                    <div className="address-item">
                        <span className="address-label">所在地区</span>
                        <input className="address-input" placeholder="所在地区" onClick={this.showAddressPicker} value={address} readOnly />
                    </div>
                    <div className="address-item">
                        <span className="address-label">详细地址</span>
                        <textarea className="address-textarea" placeholder="如街道、门牌号、小区、楼栋号、单元等" onChange={this.inputChange.bind(this, 'detail')}></textarea>
                    </div>
                </div>
                <button className={`btn-sure${canSubmit ? ' active' : ''}`} onClick={this.toSubmit}>确认</button>
                <PickerAddress defaultValue={defaultAddress} onChange={this.onChange} onConfirm={this.handleClose} onCancel={this.handleCancel} visible={visible} />
            </div>
        </DocumentTitle>
    }
}


// WEBPACK FOOTER //
// ./src/components/addAddressPage/index.jsx